<template>
    <main class="page-shell narrow auth-page">
        <b-alert v-model="showRegisterSuccessAlert" variant="success">Register successful!</b-alert>
        <b-alert v-model="showFailedLoginAlert" variant="danger">{{ failedLoginMessage}}</b-alert>

        <section class="brand-panel auth-panel text-center">
            <div class="site-logo justify-content-center">
                <img src="/assets/sidestream-logo.svg" alt="" aria-hidden="true">
                <span>sidestream.games</span>
            </div>

            <div class="auth-badge-row">
                <span class="brand-kicker">Streamer access</span>
            </div>
            <h1 class="auth-title">Sign in.</h1>
            <p class="auth-copy">Jump back into your Sidestream control panel.</p>

            <form @submit.prevent="login" class="auth-form">
                <div class="form-group">
                    <input required v-model="username" type="email" placeholder="user@example.com" class="form-control">
                </div>
                <div class="form-group">
                    <input required v-model="password" type="password" placeholder="password" class="form-control">
                </div>
                <button type="submit" class="btn btn-primary btn-lg w-100">Login</button>
            </form>
        </section>

        <section class="auth-actions brand-panel">
            <RegisterForm></RegisterForm>
            <ResetPasswordForm></ResetPasswordForm>
            <a class="public-site-link" href="https://sidestream.games">Back to sidestream.games</a>
        </section>
    </main>
 
</template>

<script>
import Vue from 'vue'
import AuthService from '@/services/auth.service.js'
import AdminService from '@/services/admin.service.js'

import { BAlert } from 'bootstrap-vue'
import RegisterForm from './RegisterForm'
import ResetPasswordForm from './ResetPasswordForm'

Vue.component('b-alert', BAlert);
Vue.component('RegisterForm', RegisterForm);
Vue.component('ResetPasswordForm', ResetPasswordForm);

async function onLoginSuccess(context) {
    await AdminService.setAdmin();
    context.$root.$emit('FooterUpdateEvent');

    context.showFailedLoginAlert = false;
    context.$router.push({ path: '/' })
}

function onLoginFailed(context, error) {
    if (!error.response) {
        context.failedLoginMessage = 'Check your connection'
        context.showFailedLoginAlert = true;
        return;
    }
    if (error.response.status == 401) {
        context.failedLoginMessage = 'Incorrect login details'
        context.showFailedLoginAlert = true;
    }
}


export default {
    name: 'LoginForm',
    data () {
        return {
            username: null,
            password: null,
            showFailedLoginAlert: false,
            failedLoginMessage: 'Internal error',

            showRegisterSuccessAlert: false
        }
    },

    methods: {
        async login() {
            try {
                const response = await AuthService.login({ username: this.username, password: this.password });
                onLoginSuccess(this, response);
            } catch (error) {
                onLoginFailed(this, error);
            }
        }
    },

    created: function() {
        this.$on('register-success', () => { this.showRegisterSuccessAlert = true; });
    }

}
</script>

<style scoped>
.auth-page {
    padding-top: 2rem;
}

.auth-panel {
    padding: 1.5rem;
}

.auth-badge-row {
    margin-top: 1.35rem;
}

.auth-title {
    margin: 0;
    font-size: clamp(2.25rem, 8vw, 4rem);
    line-height: 0.95;
}

.auth-copy {
    margin: 0.75rem 0 1.25rem;
    color: var(--ss-muted);
    font-weight: 700;
}

.auth-form {
    display: grid;
    gap: 0.75rem;
}

.auth-actions {
    display: grid;
    gap: 0.65rem;
    margin-top: 1rem;
    padding: 1rem;
    text-align: center;
}

.public-site-link {
    display: inline-flex;
    justify-content: center;
    width: 100%;
    padding-top: 0.65rem;
    border-top: 2px solid rgba(22, 20, 15, 0.12);
    color: var(--ss-muted);
    font-size: 0.92rem;
    font-weight: 900;
}
</style>
